export const CLASS_USER_SETTINGS = 'user-settings-dialog';

export const USER_SETTINGS_DIALOG_PORTAL = 'user-settings-dialog-portal';
